var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconCommunications(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icon_Communications",
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 17.958,
    viewBox: "0 0 18 17.958",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "comments",
    d: "M17.073,3.833a.892.892,0,0,1,.654.274A.844.844,0,0,1,18,4.718v13.49l-3.625-3.583H4.511a.892.892,0,0,1-.654-.274.846.846,0,0,1-.274-.611V11.927H15.3V3.833Zm-3.583,5.4a.825.825,0,0,1-.274.632.88.88,0,0,1-.611.253H3.583L0,13.74V1.135A.825.825,0,0,1,.274.5.88.88,0,0,1,.885.25H12.6A.879.879,0,0,1,13.216.5a.827.827,0,0,1,.274.632Z",
    transform: "translate(0 -0.25)",
    fill: "#4f4f4f"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCommunications);
export default __webpack_public_path__ + "static/media/Icon_Communications.ae0c7c7fc7e13c4e4719383cac4d1844.svg";
export { ForwardRef as ReactComponent };